import { render } from "./AddProduct.vue?vue&type=template&id=6ea945df"
import script from "./AddProduct.vue?vue&type=script&lang=js"
export * from "./AddProduct.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TechLHAB\\OneDrive\\Desktop\\WEBAPPS\\VueJs\\ecommerce-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__